import React from "react";
import Geosuggest from "react-geosuggest";
import {
  addressFromGoogleSuggestion,
  addressDisplayValue
} from "./addressUtils";

class AddressInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: addressDisplayValue(props.value || {}),
      selectedValue: addressDisplayValue(props.value || {}),
      placesAvailable: Boolean(window?.google?.maps?.places)
    };
    this.geosuggest = null;
    this.placesCheck = null;
  }

  componentDidMount() {
    if (!this.state.placesAvailable) {
      this.placesCheck = window.setInterval(() => {
        if (window?.google?.maps?.places) {
          window.clearInterval(this.placesCheck);
          this.placesCheck = null;
          this.setState({ placesAvailable: true });
        }
      }, 250);
    }
  }

  componentDidUpdate(previousProps) {
    const previousValue = addressDisplayValue(previousProps.value || {});
    const nextValue = addressDisplayValue(this.props.value || {});

    if (previousValue !== nextValue && nextValue !== this.state.inputValue) {
      this.setState({ inputValue: nextValue, selectedValue: nextValue });
      if (this.geosuggest) this.geosuggest.update(nextValue);
    }
  }

  componentWillUnmount() {
    if (this.placesCheck) window.clearInterval(this.placesCheck);
  }

  handleTextChange = inputValue => {
    this.setState({ inputValue });
    if (this.props.onAddressChange) {
      this.props.onAddressChange(inputValue, {
        verified: inputValue === this.state.selectedValue
      });
    }
  };

  handleSelect = suggestion => {
    const address = addressFromGoogleSuggestion(suggestion);
    if (!address) return;

    const inputValue = address.formattedAddress || address.address1;
    this.setState({ inputValue, selectedValue: inputValue });
    if (this.props.onAddressSelect) this.props.onAddressSelect(address);
  };

  renderManualInput() {
    return (
      <input
        type="text"
        name={this.props.name}
        className={this.props.className}
        style={this.props.style}
        value={this.state.inputValue}
        placeholder={this.props.placeholder || "Search for an address"}
        disabled={this.props.disabled}
        required={this.props.required}
        onChange={event => this.handleTextChange(event.target.value)}
      />
    );
  }

  render() {
    const { required, id, name, country = "ca" } = this.props;
    const verified =
      Boolean(this.state.inputValue) &&
      this.state.inputValue === this.state.selectedValue;

    return (
      <div className="address-input">
        {this.state.placesAvailable ? (
          <Geosuggest
            ref={element => (this.geosuggest = element)}
            id={id || name || "address-search"}
            inputClassName={this.props.className}
            initialValue={this.state.inputValue}
            placeholder={this.props.placeholder || "Search for an address"}
            country={country}
            autoComplete="off"
            disabled={this.props.disabled}
            name={name}
            required={required}
            style={{ input: this.props.style }}
            onChange={this.handleTextChange}
            onSuggestSelect={this.handleSelect}
          />
        ) : (
          this.renderManualInput()
        )}
        {required && this.state.inputValue && !verified && (
          <small className="address-input__hint">
            Select a suggestion to verify this address, or continue with the
            manually entered value.
          </small>
        )}
      </div>
    );
  }
}

export default AddressInput;
